"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _useWindowSize = _interopRequireDefault(require("./useWindowSize"));

var _Constant = require("../Constant");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaultBreakpoints = _objectSpread(_objectSpread({}, _Constant.Width), {}, {
  XS: 0
});

var useBreakpoints = function useBreakpoints() {
  var breakpoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultBreakpoints;
  var windowSize = (0, _useWindowSize.default)(); // A sorted array of [key, value] pairs

  var sortedBreakpoints = Object.keys(breakpoints).map(function (k) {
    return [k, breakpoints[k]];
  }).sort(function (a, b) {
    return b[1] - a[1];
  });

  var getCurrentBreakpoint = function getCurrentBreakpoint() {
    // eslint-disable-next-line consistent-return, no-plusplus
    for (var i = 0; i < sortedBreakpoints.length; i++) {
      var b = sortedBreakpoints[i];

      if (windowSize.innerWidth >= b[1]) {
        return b[0];
      }
    }

    return breakpoints[breakpoints.length - 1][0];
  };

  return {
    windowSize: windowSize,
    breakpoint: getCurrentBreakpoint()
  };
};

var _default = useBreakpoints;
exports.default = _default;